import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Copy, Check } from 'lucide-react'
import { toast } from "sonner"
import { QRCodeCanvas as QRCode } from "qrcode.react"
import { useTranslation } from "react-i18next"

interface ShareableContentProps {
    shareableLink: string
    isEditing: boolean
    editShareable: boolean
}

export function ShareableContent({ shareableLink, isEditing, editShareable }: ShareableContentProps) {
    const [isCopied, setIsCopied] = useState(false)

    const handleCopyShareLink = () => {
        navigator.clipboard.writeText(shareableLink).then(() => {
            setIsCopied(true)
            setTimeout(() => setIsCopied(false), 2000)
            toast.success("Link copied", {
                description: "The shareable link has been copied to your clipboard.",
            })
        })
    }

    const isContentEnabled = !isEditing || (isEditing && editShareable)
    const {t} = useTranslation("common")
    return (
        isContentEnabled ? (
            <div className="mt-2 p-3 bg-muted rounded-md">
                <div className="text-xs font-medium text-muted-foreground mb-2">{t("common:previewViewer.share.shareableLink")}</div>
                <div className="flex items-center space-x-2">
                    <Input readOnly value={shareableLink} className="text-xs" />
                    <Button size="icon" variant="outline" onClick={handleCopyShareLink} className="flex-shrink-0">
                        {isCopied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
                    </Button>
                </div>
                <div className="flex justify-center my-2">
                    <div className="bg-white p-4 rounded-lg shadow-md">
                        <QRCode value={shareableLink} size={130} />
                    </div>
                </div>
            </div>)
            : (
                <div className="text-center p-2 border border-dashed rounded-md">
                    <p className="text-muted-foreground text-sm"> {t("common:previewViewer.share.enableShare")}</p>
                </div>
            )
    )
}
